
import mdlProvider from '@/models/Purchase/PchProvider'
import {
    generateFetchDataFunction,
    generateDeleteItemFunction,
} from '../DataTableService'

//
const includes = []
    , appends  = [ 'branch_offices']

const dtFetchData = generateFetchDataFunction( mdlProvider, includes, appends )
const dtDeleteItem = generateDeleteItemFunction(mdlProvider)
// If we need a custom route for the show and edit view:
// const showEditRoute = 'custom_route'

export default {
    dtFetchData,
    dtDeleteItem,
    //showEditRoute
}
